import { Injectable } from '@angular/core';
import { Response } from '../../common/Response';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EmopPublicWorkflowCreateApiService {
  /**
   * 获取流程模板列表
   * @param params 
   * @returns 
   */
  processDefinitionsFilter(tenant: string, batchId: string) {
    return this.http.get<Response<any>>('/workflow/v1/process-definitions/filter', {
      params: {
        tenant,
        batchId
      }
    });
  }
  /**
   * 渲染指派任务列表
   * @param data 
   * @returns 
   */
  taskDefinitions(data: string) {
    return this.http.get<Response<any>>(`/workflow/v1/process-definition/${data}/taskDefinitions`);
  }
  /**
   * 渲染指派任务默认值
   * @param template 模板
   * @param tenant 
   * @param batchId 
   * @returns 
   */
  initProcessAssignment(template: string, tenant: string, batchId: string) {
    return this.http.get<Response<any>>(`/workflow/v1/process-definition/${template}/initProcessAssignment`, {
      params: {
        tenant,
        batchId
      }
    });
  }
  /**
   * 获取审批对象
   * @param tenant 
   * @param batchId 
   * @returns 
   */
  startTaskPayload(tenant: string, batchId: string) {
    return this.http.get<Response<any>>(`/workflow/v1/process-definition/startTaskPayload`, {
      params: {
        tenant,
        batchId
      }
    });
  }
  /**
   * 创建流程
   */
  createWorkflow(data: {
    tenant: string;
    batchId: string;
    businessObjects: {}[];
    definitionId: string;
    definitionKey: string;
    processAssignment: any;
    workflowName: string;
    workflow_name: string;
    remark: string;
  }) {
    return this.http.post<Response<any>>(`/workflow/process/engine/start`, data);
  }
  constructor(
    private http: HttpClient
  ) { }
}
